import { RewardPoints1 } from '@jucy/rentals-api-client/rentals-api-v3';

export default class RewardPoints {
    bonusPoints = 0;
    identifier = '';
    pointMultiplier = 0;
    type: string = '';

    constructor(props?: Partial<RewardPoints1>) {
        Object.assign(this, props);
    }

    static fromApi(data: Partial<RewardPoints1>) {
        return new RewardPoints(data);
    }

    toPlain() {
        return {
            bonusPoints: this.bonusPoints,
            identifier: this.identifier,
            pointMultiplier: this.pointMultiplier,
            type: this.type,
        } as RewardPoints1;
    }
}
